<template>
  <editor id="editor" v-model="content" :width="width" :height="height" @init="editorInit();" :lang="lang" theme="monokai">
  </editor>
</template>

<script>
export default {
  props: ['contentProp', 'width', 'height', 'readonly', 'scrollToLine', 'lang'],
  components: {
    editor: require('vue2-ace-editor')
  },
  data () {
    return {
      editor: Object,
      content: ''
    }
  },
  methods: {
    editorInit: function () {
      require('vue-ace-editor/node_modules/brace/mode/sql')
      require('vue-ace-editor/node_modules/brace/mode/javascript')
      require('vue-ace-editor/node_modules/brace/mode/xml')
      require('vue-ace-editor/node_modules/brace/mode/powershell')
      require('vue-ace-editor/node_modules/brace/mode/less')
      require('vue-ace-editor/node_modules/brace/theme/monokai')
    },
    setContent: function (val) {
      let vm = this
      vm.content = val
      vm.scrollToEnd(vm.contentProp)
    },
    scrollToEnd: function (val) {
      let vm = this
      if (vm.scrollToLine) {
        let lines = val.split(/\r\n|\r|\n/).length
        vm.editor = window.ace.edit('editor')
        vm.editor.resize(true)
        vm.editor.gotoLine(lines, 10, true)
      }
    }
  },
  mounted () {
    let vm = this
    vm.editor = window.ace.edit('editor')
    vm.editor.setOption('showPrintMargin', false)
    vm.editor.setReadOnly(vm.readonly)
    vm.editor.session.setUseWrapMode(true)
    vm.editor.session.setWrapLimit(vm.width)
    vm.setContent(vm.contentProp)
  },
  computed: {
  },
  watch: {
    'contentProp': function (val) {
      let vm = this
      vm.setContent(val)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TextEditor.vue?062626da